module.exports = __webpack_public_path__ + "static/img/notify_default.86f97372.png";